
export default function TrustBadges() {
  return (
    <div className="bg-white py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Trusted & Accredited</h3>
          <p className="text-gray-600">Licensed professionals with proven track record</p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 items-center justify-items-center">
          {/* BBB A+ Rating */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-2 mx-auto">
              <span className="text-white font-bold text-sm">BBB</span>
            </div>
            <div className="text-sm font-semibold text-gray-900">A+ Rating</div>
            <div className="text-xs text-gray-600">Better Business Bureau</div>
          </div>

          {/* Licensed & Bonded */}
          <div className="text-center">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-2 mx-auto">
              <i className="fas fa-shield-alt text-white text-xl"></i>
            </div>
            <div className="text-sm font-semibold text-gray-900">Licensed</div>
            <div className="text-xs text-gray-600">& Bonded</div>
          </div>

          {/* 15+ Years Experience */}
          <div className="text-center">
            <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mb-2 mx-auto">
              <i className="fas fa-award text-white text-xl"></i>
            </div>
            <div className="text-sm font-semibold text-gray-900">15+ Years</div>
            <div className="text-xs text-gray-600">Experience</div>
          </div>

          {/* 1200+ Happy Clients */}
          <div className="text-center">
            <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mb-2 mx-auto">
              <i className="fas fa-users text-white text-xl"></i>
            </div>
            <div className="text-sm font-semibold text-gray-900">1,200+</div>
            <div className="text-xs text-gray-600">Happy Clients</div>
          </div>
        </div>

        {/* Security Badges */}
        <div className="flex justify-center space-x-8 mt-8 pt-6 border-t border-gray-200">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <i className="fas fa-lock text-green-600"></i>
            <span>SSL Secured</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <i className="fas fa-user-shield text-blue-600"></i>
            <span>Privacy Protected</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <i className="fas fa-certificate text-purple-600"></i>
            <span>IAPDA Certified</span>
          </div>
        </div>
      </div>
    </div>
  );
}
